import Vue from 'vue'

/* globals $ */

const Automount = (name, vueClass, extra = {}) => {
  const elements = document.querySelectorAll(name)
  Array.from(elements).forEach((el) => {
    let props = $(el).data()
    props.html = $(el).html()
    new Vue({
      ...extra,
      el,
      render: h => h(vueClass, {
        props: props
      })
    })
  })
}

export default Automount
